import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState, useCallback } from 'react';
const ThemeContext = createContext(undefined);
const STORAGE_KEY = 'civille:theme';
function resolveIsDark(theme) {
    if (theme === 'dark')
        return true;
    if (theme === 'light')
        return false;
    return typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches;
}
export function ThemeProvider({ children }) {
    const [theme, setThemeState] = useState(() => localStorage.getItem(STORAGE_KEY) ?? 'system');
    const [isDark, setIsDark] = useState(() => resolveIsDark(theme));
    useEffect(() => {
        const dark = resolveIsDark(theme);
        setIsDark(dark);
        document.documentElement.classList.toggle('dark', dark);
        document.documentElement.dataset.theme = dark ? 'dark' : 'light';
        localStorage.setItem(STORAGE_KEY, theme);
    }, [theme]);
    useEffect(() => {
        if (theme !== 'system')
            return;
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        const listener = () => setIsDark(mql.matches);
        mql.addEventListener('change', listener);
        return () => mql.removeEventListener('change', listener);
    }, [theme]);
    const toggleTheme = useCallback(() => setThemeState((t) => (t === 'dark' ? 'light' : 'dark')), []);
    return (_jsx(ThemeContext.Provider, { value: { theme, isDark, setTheme: setThemeState, toggleTheme }, children: children }));
}
export function useTheme() {
    const ctx = useContext(ThemeContext);
    if (!ctx)
        throw new Error('useTheme must be used within ThemeProvider');
    return ctx;
}
//# sourceMappingURL=ThemeContext.js.map